import config from '@/config'

const DEFAULT_TITLE = 'Aetos Terra'

// VITE_APP_LOGO is a URL (root-relative path into public/, or absolute) to a
// custom logo image, e.g. VITE_APP_LOGO=/uzma-logo.svg. Empty -> built-in
// Aetosky logo.
export function customLogoUrl(): string | undefined {
  return config.appLogo.trim() || undefined
}

export function isCustomLogo(): boolean {
  return customLogoUrl() !== undefined
}

export function resolveDocumentTitle(): string {
  return config.appName.trim() || DEFAULT_TITLE
}

export function applyDocumentTitle(): void {
  document.title = resolveDocumentTitle()
}

export function applyFavicon(): void {
  if (!config.appFavicon) return
  const link =
    document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
    document.head.appendChild(document.createElement('link'))
  link.rel = 'icon'
  link.href = config.appFavicon
}
